export const ADVANCED_FILTER_QUERY_KEYS = [
  "duration_min",
  "duration_max",
  "price_min",
  "price_max",
  "adventure_styles",
  "broad_categories",
  "weekend",
];

const numberOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const parseAdvancedFilters = (searchParams) => ({
  durationMin: numberOrNull(searchParams.get("duration_min")),
  durationMax: numberOrNull(searchParams.get("duration_max")),
  priceMin: numberOrNull(searchParams.get("price_min")),
  priceMax: numberOrNull(searchParams.get("price_max")),
  adventureStyles: (searchParams.get("adventure_styles") || "")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean),
  broadCategories: (searchParams.get("broad_categories") || "")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean),
  weekend: searchParams.get("weekend") === "1",
});

export const serializeAdvancedFilters = (searchParams, filters) => {
  const nextParams = new URLSearchParams(searchParams.toString());

  ADVANCED_FILTER_QUERY_KEYS.forEach((key) => nextParams.delete(key));

  if (filters.durationMin !== null && filters.durationMin !== undefined) {
    nextParams.set("duration_min", String(filters.durationMin));
  }
  if (filters.durationMax !== null && filters.durationMax !== undefined) {
    nextParams.set("duration_max", String(filters.durationMax));
  }
  if (filters.priceMin !== null && filters.priceMin !== undefined) {
    nextParams.set("price_min", String(filters.priceMin));
  }
  if (filters.priceMax !== null && filters.priceMax !== undefined) {
    nextParams.set("price_max", String(filters.priceMax));
  }
  if (Array.isArray(filters.adventureStyles) && filters.adventureStyles.length > 0) {
    nextParams.set("adventure_styles", filters.adventureStyles.join(","));
  }

  // broad_categories is a separate filter; preserve the `broad` tab param as-is
  if (Array.isArray(filters.broadCategories) && filters.broadCategories.length > 0) {
    nextParams.set("broad_categories", filters.broadCategories.join(","));
  }

  // Weekend filter
  nextParams.delete("weekend");
  if (filters.weekend) {
    nextParams.set("weekend", "1");
  }

  return nextParams;
};
